import { Grid } from "@material-ui/core";
import { useRackDelete } from "@saleor/dropOff/mutation";
import { useRacksQuery } from "@saleor/dropOff/queries";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { RacksQuery_racks_edges_node } from "@saleor/dropOff/types/RacksQuery";
import { TemplateAction } from "@saleor/dropOff/utils/handlers";
import useNotifier from "@saleor/hooks/useNotifier";
import { handleGraphQLErrors } from "@saleor/utils/handlers/errorHandler";
import React from "react";

import DropOffRackCard from "./DropOffRackCard";

interface DropOffRackListProps {
  selectedHomeLocation: string | null;
  templateId: string | null;
  editRacksAndBinsEvent: (rack: RacksQuery_racks_edges_node) => void;
  selectedRackId: string;
  clearForm: () => void;
  templateAction: TemplateAction;
}

const DropOffRackList: React.FC<DropOffRackListProps> = props => {
  const {
    selectedHomeLocation,
    templateId,
    editRacksAndBinsEvent,
    selectedRackId,
    clearForm,
    templateAction
  } = props;

  const classes = useTemplateStyles(props);
  const notify = useNotifier();

  const { data: racks, refetch } = useRacksQuery({
    displayLoader: true,
    variables: {
      dropOffLocation: selectedHomeLocation,
      first: 100,
      template: templateId
    }
  });

  React.useEffect(() => {
    refetch();
  }, [selectedHomeLocation]);

  const [deleteRacksAndBins] = useRackDelete({
    onCompleted: e => {
      if (e.rackDelete.rackError.length === 0) {
        notify({
          status: "success",
          text: "All changes saved"
        });
        refetch();
      } else {
        notify({
          status: "error",
          text: e.rackDelete.rackError[0].message
        });
      }
      clearForm();
    },
    onError: handleGraphQLErrors
  });

  const clickEdit = (rack: RacksQuery_racks_edges_node) => {
    editRacksAndBinsEvent(rack);
  };

  return (
    <div className={classes.dropOffCardAccordion}>
      <Grid container spacing={2}>
        {racks?.racks?.edges?.map(rack => (
          <Grid item xs={6}>
            <DropOffRackCard
              hideDeleteIcon={templateAction === TemplateAction.VIEW}
              rackName={rack?.node?.name}
              numberOfBins={rack?.node?.bins?.totalCount}
              rackId={rack?.node?.id}
              onDelete={rackId => {
                deleteRacksAndBins({ variables: { id: rackId } });
              }}
              onCardClick={() => {
                clickEdit(rack?.node);
              }}
              isSelected={rack?.node?.id === selectedRackId}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default DropOffRackList;
